import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { ClienteAnaliseFinanceira } from '../cliente-analise-financeira';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseFinanceiraConcluirHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/clienteanalisefinanceira`;
    }

    /** Conclui a análise financeira do cliente */
    concluir(cliente: ClienteAnaliseFinanceira): Observable<ClienteAnaliseFinanceira> {
        return this.customHttp.put<ClienteAnaliseFinanceira>(`${this.pathApi}/${cliente.id}/concluir`, cliente);
    }

    /** Cancela a conclusão da análise financeira */
    cancelarConcluir(idCliente: number): Observable<ClienteAnaliseFinanceira> {
        return this.customHttp.put<ClienteAnaliseFinanceira>(`${this.pathApi}/${idCliente}/concluir/cancelar`, null);
    }
}
